export default __webpack_public_path__ + "static/media/altosSalta4_g.5080c142.jpg";